import { Promise } from 'core-js'
import Vue from 'vue'
import router from './../../router'

import Chat from './services/chat'

const store = new Vue.observable({
  ready: false,
  stats: {
    newCount: 0,
    newMessageCount: 0,
    hasNew: false
  }
})

let pushNotifications = [];

let eventbus = new Vue();

const ChatCollection = {
  isReady: () => store.ready,
  initialised: async () => {
    while (!store.ready) {
      await new Promise(resolve => setTimeout(resolve, 300))
    }
    return
  },
  init: async () => {
    if (!store.ready) {
      store.ready = true
      ChatCollection.getStats();
      console.log("ChatCollection init")
    }
  },
  eventbus,
  getStats: async () => {
    const stats = await Chat.getStats({ignoreCache: true}).then(({data}) => data);
    if(!stats) return null;
    store.stats.newCount = stats.newCount || 0;
    store.stats.newMessageCount = stats.newMessageCount || 0;
    store.stats.hasNew = stats.hasNew || false;

    return store.stats;
  },
  add: ({ title, body, data = {} }) => {
    //get chat stats
    // ChatCollection.getStats();
    
    if(!window.parent.CapacitorCustomPlatform) return;

    function newNotification({title, body, data}) {
      const notification = new Notification(title, {
        body,
        data: "chat"
      });

      notification.onclick = () => {
        ChatCollection.clickFunction({title, body, data});
      };

      console.log(notification);

      pushNotifications.push(notification);

      return notification;
    }

    if (!("Notification" in window)) {
      // Check if the browser supports notifications
      alert("This browser does not support desktop notification");
    } else if (Notification.permission === "granted") {
      // Check whether notification permissions have already been granted;
      // if so, create a notification
      newNotification({ title, body, data });
      // …
    } else if (Notification.permission !== "denied") {
      // We need to ask the user for permission
      Notification.requestPermission().then((permission) => {
        // If the user accepts, let's create a notification
        if (permission === "granted") {
          newNotification({ title, body, data });
        }
      });
    }
  },
  clickFunction(notification = {}) {
    // alert(JSON.stringify(notification));

    try {
      const { data: notificationData = {} } = notification;
      let { action: actionData = {} } = notificationData;

      if(typeof actionData === "string") {
        try {
          actionData = JSON.parse(actionData);
        } catch (error) {
          console.log(error);
          actionData = {};
        }
      }

      const { type, action, messageId, groupId } = actionData;

      if(action === "message" && type === "chat") {
        return router.push({
          name: "main.chat.details",
          params: {groupId},
          query: {
            messageId
          },
        });
      }
    } catch (error) {
      console.log("ERROR",error);
      alert(JSON.stringify(error));
    }
  },
  clearNotifications() {
    pushNotifications.forEach(foundLocal => {
      foundLocal.close();
    });

    const PushNotifications = window.parent?.Capacitor?.Plugins?.PushNotifications;
    if(PushNotifications) {
      PushNotifications.getDeliveredNotifications().then(({ notifications }) => {
        // alert(JSON.stringify(notifications));
        console.log("notifications",notifications);
        const foundPush = notifications.filter(({data = {}}) => !!data?.action?.chatId);
        if(foundPush.length) PushNotifications.removeDeliveredNotifications({notifications:foundPush}).then(res => console.log(res), err => console.log(err));
        else console.log("not found");
      }, err => console.log(err));
    }
  },
  newCount: () => store.stats.newCount,
  newMessageCount: () => store.stats.newMessageCount,
  hasNew: () => store.stats.hasNew
}

export default ChatCollection